import script from "./FamilyGroupInviteItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupInviteItem.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupInviteItem.vue?vue&type=style&index=0&id=68b710aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b710aa"]])

export default __exports__